import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { provideIcons } from '@ng-icons/core'
import { appIcons } from './constants/icons'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [provideIcons(appIcons)],
})
export class App {
  constructor() {
    const html = document.documentElement
    html.setAttribute('data-skin', 'shadcn')
    html.setAttribute('data-bs-theme', 'light')
    html.setAttribute('data-sidenav-color', 'light')
    html.setAttribute('data-topbar-color', 'light')
    html.setAttribute('data-sidenav-size', 'default')
    html.setAttribute('data-layout-position', 'fixed')
    html.setAttribute('data-sidenav-user', 'true')
  }
}
